// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.inquiry.HpApiInquiryV3Handler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  HpApiInquiryV3Handler_create,
  HpApiInquiryV3Handler_prefill,
  HpApiInquiryV3Handler_prefill_Path,
} from '@zg-rentals/ts-hotpads-api-client';

import type {
  HpApiResponseDto,
  HpInquiryPrefillDto,
  HpInquiryRequestDto,
  HpInquiryResponseDto,
} from '@zg-rentals/ts-hotpads-api-client';

export interface HpApiInquiryV3Handler_create_Args {
  postData: HpInquiryRequestDto;
}

export type HpApiInquiryV3Handler_create_Options = UseMutationOptions<
  HpApiResponseDto<HpInquiryResponseDto>,
  unknown,
  HpApiInquiryV3Handler_create_Args
>;

/**
 * Submit a listing inquiry; the inquirer email is taken from the authenticated session
 */
export const useHpApiInquiryV3Handler_create = ({
  httpClient,
  ...options
}: Omit<HpApiInquiryV3Handler_create_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiInquiryV3Handler_create_Args) => HpApiInquiryV3Handler_create(args.postData, httpClient),
  });
};

export type HpApiInquiryV3Handler_prefill_Options = UseQueryOptions<
  HpApiResponseDto<HpInquiryPrefillDto>,
  unknown,
  HpApiResponseDto<HpInquiryPrefillDto>,
  readonly [string]
>;

const HpApiInquiryV3Handler_prefill_GetKey = () => [HpApiInquiryV3Handler_prefill_Path] as const;

export const HpApiInquiryV3Handler_prefill_queryOptions = ({ httpClient }: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: HpApiInquiryV3Handler_prefill_GetKey(),
    queryFn: () => HpApiInquiryV3Handler_prefill(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Prefill the contact form from the user's renter profile and most recent inquiry
 */
export const useHpApiInquiryV3Handler_prefill = ({
  httpClient,
  ...options
}: Omit<HpApiInquiryV3Handler_prefill_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...HpApiInquiryV3Handler_prefill_queryOptions({ httpClient }),
    ...options,
  });
};
useHpApiInquiryV3Handler_prefill.getKey = HpApiInquiryV3Handler_prefill_GetKey;
